module.exports = __webpack_public_path__ + "img/wechat.aecca6c4.png";